<template>
	<div class="footerComp">
		<div
						class="modal" id="getStarted" tabindex="-1"
						role="dialog" aria-labelledby="getStarted"
						aria-hidden="true">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Get Started</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close" id="close-get-started">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="form-group">
							<label>Name</label>
							<input
											type="email" id="gs-name" class="form-control" v-model="name" aria-describedby="emailHelp"
											required>
						</div>
						<div class="form-group">
							<label>Email address</label>
							<input
											type="email" class="form-control" v-model="email" id="gs-email" required
											aria-describedby="emailHelp">
						</div>
						<div class="form-group">
							<label>Phone Number</label>
							<input
											type="text" class="form-control" v-model="number" required id="gs-number"
											aria-describedby="emailHelp">
						</div>
						<div class="form-group">
							<label>Select the purpose</label>
							<select class="form-control" v-model="purpose" required id="gs-purpose">
								<option value="customer_engagement">Customer Engagement</option>
								<option value="remote_teams">Remote Working Teams</option>
								<option value="classrooms">Remote Classrooms</option>
							</select>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary text-dark" id="get-started-submit" @click="submitGetStarted">
							<b>Submit</b>
						</button>
					</div>
				</div>
			</div>
		</div>
		<footer class="footer">
			<div class="container">
				<div class="row">
					<div class="col-lg-6 h-100 text-center text-lg-left my-auto">
						<ul class="list-inline mb-2">
							<li class="list-inline-item">
								<router-link to="/about" id="footer-about">About</router-link>
							</li>
							<li class="list-inline-item">&sdot;</li>
							<li class="list-inline-item" >
								<a href="javascript:void(0)" data-toggle="modal" data-target="#getStarted" id="footer-contact">Contact</a>
							</li>
							<li class="list-inline-item">&sdot;</li>
							<li class="list-inline-item" >
								<router-link to="/terms-of-use" id="footer-terms">Terms of Use</router-link>
							</li>
							<li class="list-inline-item">&sdot;</li>
							<li class="list-inline-item">
								<router-link to="/privacy-policy"  id="footer-privacy">Privacy Policy</router-link>
							</li>
						</ul>
						<p class="text-muted small mb-4 mb-lg-0">&copy; 2020. All Rights Reserved.</p>
					</div>
					<div class="col-lg-6 h-100 text-center text-lg-right my-auto">
						<ul class="list-inline mb-0">
							<li class="list-inline-item mr-3">
								<a href="https://www.facebook.com/MeetBeans" target="_blank">
									<i class="fab fa-facebook fa-2x fa-fw"  id="footer-facebook"></i>
								</a>
							</li>
							<li class="list-inline-item mr-3">
								<a href="https://twitter.com/meetbeans" target="_blank">
									<i class="fab fa-twitter fa-2x fa-fw" id="footer-twitter"></i>
								</a>
							</li>
							<li class="list-inline-item mr-3">
								<a href="https://www.instagram.com/meetbeans_official/" target="_blank">
									<i class="fab fa-instagram fa-2x fa-fw" id="footer-instagram"></i>
								</a>
							</li>
							<li class="list-inline-item">
								<a href="https://www.linkedin.com/company/65466032" target="_blank">
									<i class="fab fa-linkedin fa-2x fa-fw"  id="footer-linkedin"></i>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</footer>
	</div>
</template>
<script>
  export default {
    name: 'footerComp',
    data() {
      return {
        name: "",
        email: "",
        number: "",
        purpose: ""
      }
    },
    components: {

    },
    created() {
      if (localStorage.getItem('user_info')) {
        this.name = JSON.parse(localStorage.getItem('user_info')).name
        this.email = JSON.parse(localStorage.getItem('user_info')).email
      }
    },
    methods: {
      setPurpose: function (purpose) {
        this.purpose = purpose
        if (localStorage.getItem('user_info')) {
          this.name = JSON.parse(localStorage.getItem('user_info')).name
          this.email = JSON.parse(localStorage.getItem('user_info')).email
        }
      },
      submitGetStarted: function () {
        if (this.name === "") {
          this.$toast.open({
            message: "Please enter name",
            type: 'error',
			position: 'top',
			queue: true
          });
        } else if (this.email === "") {
          this.$toast.open({
            message: "Please enter email",
            type: 'error',
			position: 'top',
			queue: true
          });
        } else if (this.purpose === "") {
          this.$toast.open({
            message: "Please enter purpose",
            type: 'error',
			position: 'top',
			queue: true
          });
        } else if (this.number === "") {
          this.$toast.open({
            message: "Please enter phone number",
            type: 'error',
			position: 'top',
			queue: true
          });
        } else {
          let data = {
            'name': this.name,
            'email': this.email,
            'number': this.number,
            'purpose': this.purpose
          }
          this.$store.dispatch('getStarted', data).then(resp => {
            if (resp.data.status === "success") {
              this.name = ""
              this.email = ""
              this.number = ""
              this.purpose = ""
              document.getElementById('close-get-started').click()
              this.$toast.open({
                message: "Thanks for reaching out, we will get back to you.",
                type: 'success',
				position: 'top',
				queue: true
              });
            }
          })
        }
      }
    }
  }
</script>
<style scoped>
	footer.footer {
		padding-top: 4rem;
		padding-bottom: 4rem;
		background: #1B1B1B !important;
	}
</style>
